import React from 'react';
export const Footer = () => {
  return <footer className="border-t border-gray-200 pt-6 text-sm text-gray-600" data-id="element-72">
      <div className="flex items-start mb-6" data-id="element-73">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-16 h-16 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-74" />
        <div data-id="element-75">
          <p className="font-semibold mb-2" data-id="element-76">
            Amee de Bruijn is gediplomeerd hondengedragsconsultant & Natural Dog
            Trainer (niveau 5), opgeleid bij Calming Signs in Koningslust
            (2017).
          </p>
          <p data-id="element-77">
            Ze heeft meer dan 15.000 baasjes en hun honden geholpen en werkt
            uitsluitend met methodes vrij van dwang, pijn, angst en straf. Meer
            dan 100.000 baasjes hebben haar webinars bekeken.
          </p>
        </div>
      </div>
      <div className="border-t border-gray-200 pt-4 pb-2" data-id="element-78">
        <p className="text-xs text-center text-gray-500 mb-2" data-id="element-79">
          © 2023 Liefdevol Communiceren. Alle rechten voorbehouden.
        </p>
        <p className="text-xs text-center text-gray-500" data-id="element-80">
          <strong data-id="element-81">Disclaimer:</strong> Stressless Dogs is een onafhankelijk
          bedrijf en heeft geen relatie met Meta Platforms, Inc. (voorheen
          Facebook, Inc.). Deze advertentie wordt niet gesponsord, goedgekeurd
          of beheerd door Meta, en Meta is niet verantwoordelijk voor de inhoud
          of diensten die worden aangeboden door Stressless Dogs.
        </p>
      </div>
    </footer>;
};